<div class="employee-profile-box">
  <div class="employee-profile-box__container" (click)="handleProfileBoxClick($event)">
    <ng-container *ngIf="(accountType$ | async) === 'employee'; else impersonatedIcon">
      <svg
        class="employee-profile-box__avatar"
        width="32"
        height="30"
        viewBox="0 0 32 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.7075 0.865234C7.0325 0.865234 0 7.89774 0 16.5728C0 21.7087 2.46492 26.2689 6.27629 29.1349C9.23244 27.8576 10.3649 27.3408 10.3649 27.3408C10.3649 27.3408 10.6271 27.0865 10.8892 26.4328C11.1515 25.779 10.8892 25.2705 10.8892 25.2705L12.2067 24.9436C12.2067 24.9436 12.0879 22.8008 12.2003 22.8008C12.2189 22.8008 12.1819 22.7438 12.1069 22.6282C11.8743 22.2694 11.2754 21.3461 10.836 19.8097C10.523 19.7698 10.0339 19.3945 9.8406 17.8249C9.67431 16.475 9.946 16.2093 10.221 16.2403C10.2144 16.0917 10.2106 15.942 10.2096 15.7912C9.88778 15.1512 9.43559 14.0178 9.2932 12.4979C9.06413 10.0529 9.92314 7.49679 9.92314 7.49679C9.92314 7.49679 10.7821 8.27475 13.4164 7.38566C16.0507 6.49656 19.3722 6.49656 20.1739 7.71907C20.9757 8.94157 20.6321 9.83066 20.6321 9.83066C20.6321 9.83066 22.8082 11.2754 22.2355 13.4982C21.942 14.6377 21.528 15.5727 21.1942 16.2135C21.1938 16.2223 21.1934 16.2311 21.193 16.2399L21.2199 16.2398C21.4909 16.2173 21.7532 16.4932 21.5893 17.8249C21.3928 19.4202 20.8905 19.7823 20.5783 19.8117C20.1388 21.347 19.5405 22.2697 19.308 22.6283C19.233 22.7438 19.1961 22.8008 19.2147 22.8008C19.327 22.8008 19.2082 24.9436 19.2082 24.9436L20.5257 25.2705C20.5257 25.2705 20.2635 25.779 20.5257 26.4328C20.7879 27.0865 21.05 27.3408 21.05 27.3408C21.05 27.3408 22.1826 27.8576 25.1388 29.1349C28.9501 26.2689 31.4151 21.7087 31.4151 16.5728C31.4151 7.89774 24.3825 0.865234 15.7075 0.865234Z"
          fill="white"
        />
      </svg>
      <div>
        <h3>{{ employeeAccountDetails.fullName }}</h3>
        <p>
          {{ 'PAGES.AUTH.EMPLOYEE.FLYOUT.ACCOUNT.TEXT' | translate }}
        </p>
      </div>
    </ng-container>
    <ng-template #impersonatedIcon>
      <svg
        class="employee-profile-box__avatar"
        width="38"
        height="36"
        viewBox="0 0 38 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="13.0625" cy="13.25" r="13.0625" fill="#99C1FF" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.0625 0.1875C5.84828 0.1875 0 6.16367 0 13.3779C0 17.6574 2.05801 21.5013 5.23834 23.9205C7.68261 22.8539 8.61955 22.4222 8.61955 22.4222C8.61955 22.4222 8.83756 22.2086 9.05558 21.6596C9.27368 21.1106 9.05558 20.6837 9.05558 20.6837L10.1512 20.4091C10.1512 20.4091 10.0524 18.6097 10.1458 18.6097C10.1613 18.6097 10.1306 18.5618 10.0682 18.4648C9.87472 18.1635 9.3767 17.3881 9.01126 16.0979C8.75098 16.0644 8.34426 15.7493 8.18352 14.4312C8.04527 13.2979 8.27106 13.0746 8.49967 13.1005C8.49414 12.9747 8.49097 12.848 8.4902 12.7205C8.22262 12.1828 7.84709 11.2315 7.72877 9.95625C7.53827 7.90305 8.25263 5.75653 8.25263 5.75653C8.25263 5.75653 8.96698 6.40982 11.1577 5.66321C13.3484 4.91659 16.1105 4.91659 16.7773 5.94319C17.444 6.96978 17.1583 7.7164 17.1583 7.7164C17.1583 7.7164 18.968 8.92965 18.4917 10.7962C18.2474 11.7538 17.9028 12.5394 17.6251 13.0775C17.6248 13.0851 17.6245 13.0926 17.6241 13.1002L17.6466 13.1001C17.872 13.0812 18.0901 13.3129 17.9538 14.4312C17.7904 15.7708 17.3727 16.0749 17.1131 16.0996C16.7476 17.3889 16.25 18.1637 16.0566 18.4648L16.0566 18.4648L16.0566 18.4649C15.9943 18.5619 15.9636 18.6097 15.9791 18.6097C16.0725 18.6097 15.9737 20.4091 15.9737 20.4091L17.0693 20.6837C17.0693 20.6837 16.8513 21.1106 17.0693 21.6596C17.2873 22.2086 17.5054 22.4222 17.5054 22.4222C17.5054 22.4222 18.4424 22.8539 20.8867 23.9205C24.067 21.5013 26.125 17.6574 26.125 13.3779C26.125 6.16367 20.2767 0.1875 13.0625 0.1875Z"
          fill="white"
        />
        <circle cx="24.9375" cy="22.75" r="13.0625" fill="#99C1FF" />
        <mask
          id="mask0_1036_25812"
          style="mask-type: luminance"
          maskUnits="userSpaceOnUse"
          x="11"
          y="9"
          width="27"
          height="27"
        >
          <circle cx="24.9375" cy="22.75" r="13.0625" fill="white" />
        </mask>
        <g mask="url(#mask0_1036_25812)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M38 9.6875H11.875V35.8125H13.4058C13.5802 35.2467 14.0476 34.4821 15.1551 33.9276C17.1335 32.9372 20.5158 31.4357 20.5477 31.4357C20.6435 29.6466 21.7602 29.3271 21.7602 29.3271L21.8251 28.5331C19.4956 28.1912 18.0907 27.2505 18.0907 27.2505C18.0907 27.2505 18.7927 26.9949 19.5266 24.5669C19.7854 23.7109 19.7942 22.7397 19.8035 21.7219C19.8206 19.8529 19.8391 17.8269 21.4093 16.0687C22.694 14.6301 23.9965 14.402 24.9375 14.5055C25.8785 14.402 27.181 14.6301 28.4657 16.0687C30.0358 17.8269 30.0543 19.853 30.0714 21.722C30.0807 22.7397 30.0896 23.7109 30.3483 24.5669C31.0823 26.9949 31.7842 27.2505 31.7842 27.2505C31.7842 27.2505 30.3793 28.1912 28.0499 28.5331L28.1148 29.3271C28.1148 29.3271 29.2315 29.6466 29.3272 31.4357C29.3592 31.4357 32.7415 32.9372 34.7199 33.9276C35.8274 34.4821 36.2948 35.2467 36.4692 35.8125H38V9.6875Z"
            fill="white"
          />
        </g>
      </svg>
      <div class="employee-profile-box__impersonated">
        <h3>{{ customerAccountDetails.firstName }} {{ customerAccountDetails.lastName }}</h3>
        <p>
          {{ 'PAGES.AUTH.EMPLOYEE.FLYOUT.EMPLOYEE.TEXT' | translate }}:
          <strong>{{ employeeAccountDetails.fullName }}</strong>
        </p>
      </div>
    </ng-template>
    <span *ngIf="isOpen" class="flyout-arrow"></span>
  </div>
  <app-employee-flyout [isOpen]="isOpen" (onMenuClosed)="handleMenuClosed($event)"></app-employee-flyout>
</div>
